const helpers = {
	parseSearchParams: (paramStr) => {
		let params = {};

		paramStr = decodeURI(paramStr);

		if (paramStr.substr(0, 1) == '?') {
			paramStr = paramStr.substr(1);
		}

		if (paramStr.split('&').length > 0) {
			paramStr.split('&').forEach((item, i) => {
				if (item.split('=')[0]) {
					params[item.split('=')[0]] = item.split('=')[1];
				}
			});
		}

		return params;
	},

	searchParamString: (params) => {
		let searchParams = [];

		for (var param in params) {
			searchParams.push(param+'='+
				(Array.isArray(params[param]) ? (
					params[param].map((item) => item.id || item).join(',')
				) : params[param])
			);
		}

		return '?'+searchParams.join('&');
	},

	updateSearchParams: (paramStr, newParams) => {
		let currentParams = helpers.parseSearchParams(paramStr);

		for (var param in newParams) {
			currentParams[param] = newParams[param];
		}

		let searchParams = [];

		for (var param in currentParams) {
			if (currentParams[param] != undefined && currentParams[param] != '') {
				searchParams.push(param+'='+
					(Array.isArray(currentParams[param]) ? (
						currentParams[param].map((item) => item.id || item).join(',')
					) : currentParams[param])
				);
			}
		}

		return '?'+searchParams.join('&');
	},

	months: [
		'janúar',
		'febrúar',
		'mars',
		'apríl',
		'maí',
		'júní',
		'júlí',
		'ágúst',
		'september',
		'október',
		'nóvember',
		'desember'
	],

	formatDate: (dateStr) => {
		try {
			let d = new Date(dateStr);

			return d.getDate()+'. '+helpers.months[d.getMonth()]+' '+d.getFullYear();
		}
		catch(e) {
			return '';
		}
	}
}

export default helpers;
